import { config } from "../config";
import { callGateway, type CallerIdentity } from "./gateway";

/**
 * Pin-backed plans (owner 2026-10-10): an operator that buys pins marks one of
 * its plans; every recharge, new user or plan change on it then uses one pin
 * it holds that covers the floor below, or is refused ("no pin left").
 * radaccess /access/operator/{ns}/pinbackedplans; raduser enforces.
 */
export interface PinBackedPlan {
  namespace: string;
  groupname: string;
  minspeedmbps: number;
  mintermdays: number;
  createdby?: string;
  createdat: string;
}

const base = (ns: string) => `/operator/${encodeURIComponent(ns)}/pinbackedplans`;

export async function listPinBackedPlans(identity: CallerIdentity, ns: string, signal?: AbortSignal): Promise<PinBackedPlan[]> {
  const r = await callGateway<PinBackedPlan[] | null>(identity, config().gatewayBase, base(ns), signal ? { signal } : {});
  return r.data ?? [];
}

export async function markPinBackedPlan(identity: CallerIdentity, ns: string, groupname: string, minspeedmbps: number, mintermdays: number): Promise<PinBackedPlan> {
  const r = await callGateway<PinBackedPlan>(identity, config().gatewayBase, base(ns), {
    method: "PUT",
    body: { groupname: groupname.trim(), minspeedmbps, mintermdays },
  });
  return r.data;
}

export async function unmarkPinBackedPlan(identity: CallerIdentity, ns: string, groupname: string): Promise<void> {
  await callGateway<unknown>(identity, config().gatewayBase, `${base(ns)}/${encodeURIComponent(groupname)}`, { method: "DELETE" });
}

/** A whole number in range, or the reason it is not. */
export function floorError(text: string, label: string, max: number): string | null {
  if (!/^\d+$/.test(text.trim())) return `${label} must be a whole number`;
  const n = Number(text);
  if (n < 1 || n > max) return `${label} must be 1 to ${max}`;
  return null;
}
